module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"quesiton":"問題","answer":"回答"},"en":{"quesiton":"Quesiton","answer":"Answer"}}')
  delete Component.options._Ctor
}
